import PropTypes from "prop-types"
import React, { useEffect, useState } from "react"

import {
  Switch,
  BrowserRouter as Router,
  Route,
  Redirect,
} from "react-router-dom"
import { connect, useDispatch, useSelector } from "react-redux"

// Import Routes all
import {
  branchAdminRoutes,
  publicRoutes,
  managingDirectorRoutes,
  generalManagerRoutes,
  enquiryManagerRoutes,
  enquiryAnalystRoutes,
  salesExecutiveRoutes,
  salesManagerRoutes,
  branchManagerRoutes,
  purchaseManagerRoutes,
  inspectionUserRoutes,
  headQuartersRoutes,
  businessDevelopmentOfficerRoutes,
  teamMemberRoutes,
} from "./routes"

// Import all middleware
import Authmiddleware from "./routes/route"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import "./assets/scss/custom.scss"
import "./assets/scss/Pages.scss"
import "react-date-range/dist/styles.css" // main style file
import "react-date-range/dist/theme/default.css" // theme css file

import { getProfile } from "store/actions"

const token = localStorage.getItem("token")
const role = localStorage.getItem("role")

const App = props => {
  const dispatch = useDispatch()

  const { user } = useSelector(state => ({
    user: state.Login.user,
  }))

  useEffect(() => {
    dispatch(getProfile())
  }, [dispatch])

  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  const Layout = getLayout()

  function handleRoutesByRole() {
    // let Routes = commonRoute
    switch (user?.role ? user?.role : role) {
      case "superAdmin":
        return headQuartersRoutes
      case "admin":
        return branchAdminRoutes
      case "managingDirector":
        managingDirectorRoutes
      case "generalManager":
        return generalManagerRoutes
      case "enquiryManager":
        return enquiryManagerRoutes
      case "enquiryAnalyst":
        return enquiryAnalystRoutes
      case "salesExecutive":
        return salesExecutiveRoutes
      case "salesManager":
        return salesManagerRoutes
      case "branchManager":
        return branchManagerRoutes
      case "purchaseManager":
        return purchaseManagerRoutes
      case "inspectionUser":
        return inspectionUserRoutes
      case "businessDevelopmentOfficer":
        return businessDevelopmentOfficerRoutes
      case "teamMember":
        return teamMemberRoutes
      default:
        return branchAdminRoutes
    }
  }

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    const isReloading = sessionStorage.getItem("branchReloading")

    if (isReloading) {
      setLoading(true)
    }

    setTimeout(() => {
      // clear the flag after showing loader once
      sessionStorage.removeItem("branchReloading")
      setLoading(false)
    }, 2000)
  }, [])

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <img src="/illustrations/branch-fetching.svg" alt="Loading" />
        <h2 className="ml-4 text-xl font-semibold">
          Fetching branch details...
        </h2>
      </div>
    )
  }

  return (
    <React.Fragment>
      <Router>
        <Switch>
          {publicRoutes.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              key={idx}
              isAuthProtected={false}
              exact
            />
          ))}

          {handleRoutesByRole()?.map((route, idx) => (
            <Authmiddleware
              path={route.path}
              layout={Layout}
              component={route.component}
              key={idx}
              isAuthProtected={true}
              exact
              token={user?.token ? user?.token : token}
            />
          ))}

          <Route render={() => <Redirect to={{ pathname: "/404" }} />} />
          {!token && (
            <Route render={() => <Redirect to={{ pathname: "/login" }} />} />
          )}
        </Switch>
      </Router>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
